import { render, staticRenderFns } from "./deny-reason-widget.vue?vue&type=template&id=f1db0f5c&"
import script from "./deny-reason-widget.vue?vue&type=script&lang=js&"
export * from "./deny-reason-widget.vue?vue&type=script&lang=js&"
import style0 from "./deny-reason-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports